import { Injectable } from '@angular/core';
import { SelectionStateService } from '../selection-state.service';

/**
 * Clave de validez del cache de los reportes de jefe de ventas / administrador.
 *
 * `GlobalReportApiService` manda el rol activo en `/sales-manager/*` y el back
 * acota el scope con él: el MISMO evento devuelve números distintos según el
 * rol. Por eso "qué tengo cacheado" no es el evento solo, sino el evento dentro
 * del scope del rol (más los ejes propios de cada servicio: búsqueda, vista...).
 *
 * La clave se evalúa en el momento de LEER (`loadIfNeeded`), nunca reaccionando
 * a un cambio de rol. Un reset asincrónico corre después del `ngOnInit` de la
 * pantalla destino y la deja vacía sin nadie que vuelva a disparar la carga;
 * comparar claves al leer, en cambio, no puede perder ninguna carrera: lo peor
 * que pasa es que se vea el dato viejo un instante, nunca una pantalla muerta.
 */
@Injectable({ providedIn: 'root' })
export class ReportScopeService {

  constructor(private readonly selectionState: SelectionStateService) { }

  /** Clave estable para `parts` dentro del scope del rol activo. */
  keyFor(...parts: ReadonlyArray<string | number | null | undefined>): string {
    const role = this.selectionState.getSelectedRoleValue();

    return [role, ...parts].map((part) => String(part ?? '')).join('|');
  }

}
